import React from 'react';
import InstrumentService from "../services/instrument.service";
import {Instrument} from '../gen/api';
import InstrumentForm from "../components/InstrumentForm/InstrumentForm";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {selectInstrumentById} from "../store/selectors";
import {setErrorMessage, setSuccessMessage} from "../store/reducers/message";
import {AppDispatch} from "../store";
import {updateInstrument} from "../store/reducers/instruments";

function EditInstrument() {
  const {instrumentId} = useParams();
  const instrument = useSelector(selectInstrumentById(instrumentId));
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const submitInstrument = (editInstrument: Instrument) => {
    if (!instrumentId) return;
    InstrumentService.updateInstrument(instrumentId, editInstrument).then(response => {
      if (response) {
        dispatch(updateInstrument(response));
        dispatch(setSuccessMessage("Die Änderungen wurden gespeichert."));
      }
    }).catch(_ => dispatch(setErrorMessage("Die Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es später erneut."))
    );
  }
  const navigateToShow = () => navigate(`/show/${instrumentId}`);

  return (
      <InstrumentForm handleSubmitInstrument={submitInstrument} instrument={instrument}
                      handleAbort={navigateToShow}/>
  );
}

export default EditInstrument;